import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MenuTreeService } from "../../../../services/sale/menuTreeService.ts";
import { X } from "react-feather";

export default function PriceCodeModal({
  isOpen,
  onClose,
  productId,
  productName,
  onAdd,
}) {
  const [prices, setPrices] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [loading, setLoading] = useState(false);

  // Load prices
  useEffect(() => {
    if (!isOpen || !productId) return;

    const load = async () => {
      setLoading(true);
      setQuantities({});
      const data = await MenuTreeService.getProductPrice(productId);
      setPrices(data || []);
      setLoading(false);
    };

    load();
  }, [isOpen, productId]);

  const increase = (id) =>
    setQuantities((q) => ({ ...q, [id]: (q[id] || 0) + 1 }));

  const decrease = (id) =>
    setQuantities((q) => {
      const current = q[id] || 0;
      if (current === 0) return q;
      return { ...q, [id]: current - 1 };
    });

  const getQty = (id) => quantities[id] || 0;

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 20000,
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content border-0 shadow-lg rounded-4"
          style={{ width: "550px" }}
        >
          {/* HEADER */}
          <div className="modal-header border-0 pb-1">
            <h5 className="modal-title w-100 text-center fw-semibold">
              Product {productName} Prices
            </h5>
            <button
              className="btn btn-sm btn-light"
              onClick={onClose}
              style={{ borderRadius: "50%" }}
            >
              <X size={18} />
            </button>
          </div>

          {/* BODY */}
          <div className="modal-body" style={{ padding: "20px 28px" }}>
            {loading && <p className="text-muted">Loading prices…</p>}

            {!loading &&
              prices.map((p) => {
                const qty = getQty(p.PriceCodeID);
                const total = qty * p.ItemPrice;

                return (
                  <div
                    key={p.PriceCodeID}
                    className="card border-0 mb-3"
                    style={{
                      background: "#f7f8fc",
                      borderRadius: "6px",
                    }}
                  >
                    <div
                      className="card-body d-flex justify-content-between align-items-center"
                      style={{ padding: "15px 18px" }}
                    >
                      {/* LEFT */}
                      <div className="flex-grow-1">
                        <div className="fw-semibold">{p.Description}</div>
                        <div className="text-muted small mb-2">
                          Code: {p.PriceCode} | Tax: {p.Vat}% | Unit: {p.Unit}
                        </div>
                        <div className="d-flex justify-content-between small">
                          <span className="text-muted">Total:</span>
                          <span className="text-success fw-semibold">
                            {total.toFixed(2)}
                          </span>
                        </div>
                      </div>

                      {/* MIDDLE QTY */}
                      <div className="d-flex align-items-center mx-3">
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                          }}
                          onClick={() => decrease(p.PriceCodeID)}
                        >
                          –
                        </button>

                        <span className="mx-2 fw-semibold">{qty}</span>

                        <button
                          className="btn btn-sm btn-primary"
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                          }}
                          onClick={() => increase(p.PriceCodeID)}
                        >
                          +
                        </button>
                      </div>

                      {/* PRICE */}
                      <div className="text-end fw-semibold text-primary">
                        ${p.ItemPrice.toFixed(2)}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          {/* FOOTER */}
          <div className="modal-footer border-0 px-4 pb-4 pt-0">
            <button
              className="btn btn-primary w-100 py-2"
              style={{ fontWeight: "600" }}
              onClick={() => {
                const selected = prices
                  .map((p) => {
                    const qty = getQty(p.PriceCodeID);
                    if (!qty) return null;

                    return {
                      // product context
                      productId,
                      productName,

                      // price-code context
                      priceCodeId: p.PriceCodeID,
                      priceCode: p.PriceCode,
                      description: p.Description,
                      qty,
                      unitPrice: p.ItemPrice,
                      vat: p.Vat,
                      unit: p.Unit,
                    };
                  })
                  .filter(Boolean);

                onAdd(selected);
                onClose();
              }}
            >
              Add
            </button>

          </div>
        </div>
      </div>
    </div>
  );
}

PriceCodeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  productName: PropTypes.string,
  onAdd: PropTypes.func.isRequired,
};
